// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { isTouchDevice } from 'fg-frontend/plugins/utils';

export default class WebLayout extends WebComponent {
  constructor(props) {
    super(props);
  }

  didMount() {
    const bodyEl = this.element;

    // Třída na body když je display dotykový
    isTouchDevice() && bodyEl.classList.add('touch-device');

    /**
     * In Eshop product detail I am not able to render the amount of products before I initialize the widget with
     * product record listing. Therefore, I need some class to adjuts the layout.
     * @type {Element}
     */
    const productDetailSingleAuthor = document.querySelector('.about-author-single-container');
    if (productDetailSingleAuthor) {
      // check for slider presence
      const authorProductSlider = productDetailSingleAuthor.querySelector('.pd-authors-slider-container');
      if (!authorProductSlider) productDetailSingleAuthor.classList.add('no-products');
    }

    // scrolling to widget if there is an error state
    this.paymentWidget = document.querySelector('.widget-payment');

    if (this.paymentWidget) {
      const errorState = this.paymentWidget.querySelector('.form-group.has-error');
      if (errorState) {
        this.paymentWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/WebLayout.js